import './style/ChipRounded.css';
import React from 'react';
import { Text } from '@harperai/materialize-design-system';

const ChipRounded = ({ index, label, secondary = true, small, positive = false, negative = false}) => {
    return (
        <div key={index} className={`keystone-chip-rounded ${secondary ? "secondary" : ""} ${positive ? "positive" : ""} ${negative ? "negative" : ""} ${small ? "small" : ""}`}>
            <Text size={small ? "micro" : "caption"} bold={true} mono={true} variant={positive ? "positive" : negative ? "negative" : "primary"}>{label}</Text>
        </div>
    );
};

export default React.memo(ChipRounded);